function generateRandomInt(range?: [number, number]) {
	const [min, max] = range ?? [0, Number.MAX_SAFE_INTEGER];

	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export { generateRandomInt };
